import Share from "@/common/social/share"
import Image from "next/image"
import { Person } from "@/common/icons/person"
import { usePathData, usePropsObject } from "@/lib/contexts/appContext"

export default function PostMeta() {
  const pathData = usePathData()
  const object = usePropsObject()
  const info = []

  const hasContent = pathData.content.length > 3
  // allow for article-hero, article-sidebars and a single block

  if (object?.byline?.name) {
    info.push("Av: " + object.byline.name)
  }

  if (object.mediaAuthor) {
    info.push("Foto: " + object.mediaAuthor)
  }

  let dateLine = ["Publicerad " + object.created]

  if (object.created !== object.modified) {
    dateLine.push("Uppdaterad " + object.modified)
  }

  if (hasContent && object.readTime > 0) {
    dateLine.push(object.readTime + " min att läsa")
  }

  info.push(dateLine.join(" • "))

  const rows = info.map((item, index) => {
    return (
      <span className="block" key={index}>
        {item}
      </span>
    )
  })
  return (
    <div className="post-meta-wrapper">
      <div className="md:flex md:justify-between md:items-center">
        <div className="flex flex-1 pr-4 mb-5 font-sans text-sm leading-normal meta-data text-black-100/80 md:mb-0">
          {object?.byline && <Avatar avatar={object?.byline?.avatar} />}
          <div className="flex flex-col justify-center">{rows}</div>
        </div>
        {hasContent && <Share classes="mr-2 w-icon h-icon" url={object.url} />}
      </div>
    </div>
  )
}

const Avatar = ({ avatar }) => {
  if (!avatar) {
    return (
      <div className="flex-none">
        <figure className="flex items-center justify-center mr-3 rounded-full w-icon-lg h-icon-lg bg-black-100/10">
          <Person className="w-6 h-6 mb-1 fill-[#CCC]" />
        </figure>
      </div>
    )
  }

  return (
    <div className="flex-none mr-3">
      {avatar.url && (
        <figure className="rounded-full aspect-w-1 aspect-h-1 w-icon-lg h-icon-lg">
          <Image
            className={`rounded-full object-cover object-center w-full h-full`}
            src={avatar.url}
            sizes="256px"
            alt={avatar.alt}
            layout="fill"
            loading="lazy"
          />
        </figure>
      )}
    </div>
  )
}
